import React from "react";
import { useNavigate } from "react-router-dom";
import "assets/scss/components/subHeader.scss";
import useGoBack from "hooks/useGoBack";
import settingsIcon from "assets/images/icons/ic_settings.svg";

/**
 * @param {object} goback {goback: () => void}
 * @param {string} title 제목 (children 미전달 시 표시)
 * @param {object} menus {name: string, icon: string, callback: () => void, content?: React.ReactNode, ariaLabel?: string}
 *   content 전달 시 icon/name 대신 그대로 렌더한다 (뱃지 등 화면별 장식은 호출부가 구성)
 *   ariaLabel 미전달 시 아이콘 메뉴는 name을 라벨로 쓴다
 * @param {boolean} showSettings 설정 아이콘 표시 여부
 * @param {object} actionButton 우측 텍스트 액션 버튼 {label: string, onClick: () => void, disabled?: boolean}
 * @param {React.ReactNode} children 제목(.title) 자리에 들어갈 커스텀 콘텐츠 (예: 검색 입력창)
 * @returns {React.ReactNode}
 */
const SubHeader = ({ customGoback, title = "", menus = [], className = "", showSettings = false, actionButton = null, children = null }) => {
    const goBack = useGoBack();
    const navigate = useNavigate();

    const handleBack = () => {
        if (customGoback) {
            customGoback();
        } else {
            goBack();
        }
    };

    return (
        <div className={`sub-header ${className}`}>
            <div>
                <i className="icon icon-back" onClick={handleBack}></i>

                {children ? children : <h1 className="title">{title}</h1>}
            </div>

            <div className="menus-wrap">
                {menus && menus.map((menu) => (
                    <button
                        key={menu.name}
                        type="button"
                        className={menu.type === 'button' ? 'sub-header__btn' : 'sub-header__menu'}
                        onClick={menu.callback}
                        aria-label={menu.icon || menu.content ? (menu.ariaLabel ?? menu.name) : undefined}
                    >
                        {menu.content ?? (menu.icon ? (
                            <img
                                src={menu.icon}
                                alt=""
                            />
                        ) : (
                            <span>{menu.name}</span>
                        ))}
                    </button>
                ))}
                {actionButton && (
                    <button
                        className="sub-header__action"
                        onClick={actionButton.onClick}
                        disabled={actionButton.disabled}
                        type="button"
                    >
                        {actionButton.label}
                    </button>
                )}
                {showSettings && (
                    <div className="sub-header__settings" onClick={() => navigate('/settings')}>
                        <img src={settingsIcon} alt="설정" />
                    </div>
                )}
            </div>
        </div>
    );
};

export default SubHeader;
